import React, {useEffect} from 'react';
import {FormattedMessage} from 'react-intl';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {InviteFriendContextProvider} from '../../components/InviteFriendContext';
import PageHeader from '../../../../common/components/ui/PageHeader';
import FieldName from '../../components/FieldName';
import FieldPhone from '../../components/FieldPhone';
import ButtonSubmit from '../../components/ButtonSubmit';
import Terms from "../../components/Terms";
import FooterDivider from "../../../../common/components/ui/FooterDivider";
import FooterLogo from '../../../../common/components/ui/FooterLogo';
import styles from './InviteFriend.module.scss';

const InviteFriend = () => {
  const {setPageTitle} = useGlobalContext();

  useEffect(() => {
    setPageTitle((
      <PageHeader
        id={'inviteFriend-page-header'}
        defaultMessage={'Invite friend'}
      />
    ));
  }, []);

  return (
    <InviteFriendContextProvider>
      <div className={styles.inviteFriendContainer}>
        <div className={styles.title}>
          <FormattedMessage
            id={'inviteFriend-page-title'}
            defaultMessage={'Invite friend'}
          />
        </div>
        <div className={styles.subTitle}>
          <FormattedMessage
            id={'inviteFriend-page-sub-title'}
            defaultMessage={'Bring friends and get a free month without fees.'}
          />
        </div>
        <div className={styles.form}>
          <FieldName/>
          <FieldPhone/>
          <ButtonSubmit/>
        </div>
        <Terms/>
      </div>
      <FooterDivider/>
      <FooterLogo/>
    </InviteFriendContextProvider>
  );
};

export default InviteFriend;
